import { useParams } from "react-router-dom";
import { useChatScope } from "@/features/chat/scope/chat-scope-context";

const isValidChatId = (id: string | null | undefined): id is string =>
  typeof id === "string" && id.length === 24;

/**
 * Aktif konuşmanın kimliği. Bir `ChatScopeContext` içindeysek (ör. modül
 * dock'u) kimlik oradan gelir; değilse `/chat/:id` route param'ından.
 * Geçersiz/eksik kimlikte `null`.
 */
export const useCurrentChatId = (): string | null => {
  const scope = useChatScope();
  const { id } = useParams<{ id: string }>();

  const candidate = scope ? scope.chatId : id;
  return isValidChatId(candidate) ? candidate : null;
};
